import { useCallback } from 'react';
import PropTypes from 'prop-types';

import isCompletedClass from '@classCreation/utils/isCompletedClass';
import isOngoingClass from '@classCreation/utils/isOngoingClass';
import SbatGroupResourceType from 'propTypes/sbatGroupResourceType';

export default function useSbatGroupConfirmation(
  callback,
  sbatGroup,
  messageArgs
) {
  const { ongoingMessage, completedMessage } = messageArgs || {};

  const handleSubmit = useCallback(
    (event) => {
      event.preventDefault();
      if (isOngoingClass(sbatGroup.date_of_topic)) {
        if (
          window.confirm(
            ongoingMessage ||
              'This class is currently ongoing. Are you sure of making this change?'
          )
        ) {
          callback();
        }
      } else if (isCompletedClass(sbatGroup.date_of_topic)) {
        if (
          window.confirm(
            completedMessage ||
              'This class is already completed. Are you sure of making this change?'
          )
        ) {
          callback();
        }
      } else {
        callback();
      }
    },
    [callback, completedMessage, ongoingMessage, sbatGroup.date_of_topic]
  );

  return handleSubmit;
}

useSbatGroupConfirmation.propTypes = {
  callback: PropTypes.func.isRequired,
  sbatGroup: SbatGroupResourceType.isRequired,
  messageArgs: PropTypes.shape({
    ongoingMessage: PropTypes.string,
    completedMessage: PropTypes.string,
  }),
};
